import { inject, Injectable } from '@angular/core';
import { CompoApp } from '../CompoApp';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlBuilder } from '../../models/frontend_entities/UrlBuilder';
import Constants from '../../Constants';
import { Widget } from '../../models/dashboard/widget.model';
import { WidgetDataType } from '../../models/dashboard/widget-data-type.enum';

@Injectable()
export class UserSettingsWidgetService {

  //region INJECTIONS
  private app = inject(CompoApp);
  private http = inject(HttpClient);
  //endregion

  //region GET
  getWidgets(): Observable<Widget[]> {
    const url = new UrlBuilder(Constants.URLS.user.widgetSettings.base)
      .param('accessMode', this.app.data.getAccessMode())
      .build();

    return this.http.get<Widget[]>(url);
  }

  //endregion

  //region POTS
  createWidgets(types: WidgetDataType[]): Observable<Widget[]> {
    const url = new UrlBuilder(Constants.URLS.user.widgetSettings.base)
      .param('accessMode', this.app.data.getAccessMode())
      .build();

    return this.http.post<Widget[]>(url, types);
  }

  //endregion

  //region POST
  saveWidgetGrid(widgets: Widget[]): Observable<Widget[]> {
    const url = new UrlBuilder(Constants.URLS.user.widgetSettings.base)
      .param('accessMode', this.app.data.getAccessMode())
      .build();

    return this.http.put<Widget[]>(url, widgets);
  }

  //endregion
}
